<script>
import productMixin from '@/src/mixins/product'
import { uniq } from 'lodash'
import cloneDeep from 'lodash/cloneDeep'
export default {
  props: {
    // 最後要打api的資料
    value: {
      type: Object
    },
    defaultValue: {
      type: Object,
    }
  },
  data() {
    return {
      forSaveDeletePrice: [], // 服務項目視窗
      forSaveDeletecategoryList: [],
      productsDialogVisible: false, // 新增適用分店 跳窗 開啟/關閉
      pricesDialogVisible: false, // 新增適用服務項目 跳窗 開啟/關閉
      prepaidsDialogVisible: false, // 新增可服務的寵物類別與體型 跳窗開啟/關閉
      catchPruducts: [], // 點選到的分店
      catchPrices: [], // 點選到的服務價目
      catchPrepaids: [],

      checkAllProducts: false,
      checkAllPrices: false,
      checkAllPrepaid: false,

      productFilter: '', // 分店filter
      serviceFilter: '', // 服務項目filter
      prepaidFilter: '', // 包月方案filter

      cloneAvalibleService: [], // 所有可以使用的服務項目
      cloneCategoryList: [], // 所有體型
      cloneProduct: [], // 所有分店
      availableService: [],

      isIndeterminatePrices: true, // 服務跳窗的不確定狀態
      isIndeterminateProduct: true, // 分店跳窗的不確定狀態
      isIndeterminateCategory: true, // 體型跳窗的不確定狀態(如果false，就是全打勾)
    }
  },
  mixins: [productMixin],
  computed: {
    submitData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    validServiceCategories() {
      return (this.cloneCategoryList || []).filter(
        (item) => item && item.categoryTitle != null && String(item.categoryTitle).length > 0
      )
    },
    submitRules() {
      return {
        storeIds: [
          {
            type: 'array',
            required: this.submitData.storeIds,
            message: '請至少選擇一家分店',
            trigger: 'change',
          },
        ],
        productPriceIds: [
          {
            required: true,
            message: '請選擇服務項目',
            trigger: 'change',
          },
        ],
        serviceCategoryIds: [
          {
            required: true,
            message: `請選擇${this.$t('reserve.CLIENT')}類別與${this.$t('member.BODY_TO_TYPE')}`,
            trigger: 'change',
          },
        ],
      }
    },
    filterLocations() {
      if (this.productFilter.length === 0) {
        // this.checkAllPrices = this.cloneAvalibleService.length === this.catchPrices.length
        // this.isIndeterminatePrices = this.catchPrices.length > 0 && this.catchPrices.length < this.cloneAvalibleService.length;
        return this.cloneProduct
      } else {
        return this.cloneProduct.filter(item => item.name.includes(this.productFilter))
      }
    },
    filterService() {
      if (this.serviceFilter.length === 0) {
        this.checkAllPrices = this.cloneAvalibleService.length === this.catchPrices.length
        this.isIndeterminatePrices = this.catchPrices.length > 0 && this.catchPrices.length < this.cloneAvalibleService.length;
        return this.cloneAvalibleService
      } else {
        return this.cloneAvalibleService.filter(item => item.title.includes(this.serviceFilter))
      }
    },
    filterCategoryList() {
      const list = this.validServiceCategories
      try {
        if (this.prepaidFilter.length === 0) {
          this.checkAllPrepaid = list.length === this.catchPrepaids.length
          this.isIndeterminateCategory = this.catchPrepaids.length > 0 && this.catchPrepaids.length < list.length
          return list
        }
        return list.filter((item) => String(item.categoryTitle).includes(this.prepaidFilter))
      } catch (error) {
        console.error(error.message)
        return list
      }
    },
    // 求當前服務項目與所有適用服務項目的聯集
    unionService() {
      const set = new Set()
      const unionService = this.filterService.map(service => {
        set.add(service.title)
        return service
      })

      this.forSaveDeletePrice.forEach(service => {
        if (!set.has(service.title)) {
          unionService.push(service)
        }
      })

      return unionService
    }

  },
  methods: {
    /**
     * @description 驗證是否可以儲存
     */
    validateSelf() {
      if (this.submitData.storeIds.length === 0) {
        this.$message({
          message: '請設定至少一間分店',
          type: 'error',
        })
        return false
      } else {
        return true
      }
    },
    /**
     * @description 獲取所有分店
     */
    async tryToFetchProduct() {
      const { items } = await this.$store.dispatch('product/fetchList', {
        limit: 10000,
        page: 1,
        paginate: 0
      })
      this.cloneProduct = items
    },
    /**
     * @description 獲取所有體型
     */
    async tryToFetchCategory() {
      let categoryAll = await this.$store.dispatch('product/fetchServiceCategory', { paginate: 0 })
      let newArray = []
      categoryAll.forEach((itemParent) => {
        const children = itemParent && itemParent.children ? itemParent.children : []
        children.forEach((item) => {
          if (item) {
            newArray.push(item)
          }
        })
      })
      this.cloneCategoryList = newArray
    },
    /**
     * @description 獲取服務項目
     */
    async tryToFetchService() {
      let types = []
      if (!this.defaultValue['staffOpenServiceTree']) {
        types = this.defaultValue.types
      } else {
        types = this.defaultValue['staffOpenServiceTree']['searchTypes']
      }
      const { items } = await this.$store.dispatch('product/fetchNormalServiceData', {
        types: types ?? ['cosmetic', 'daycare'],
        paginate: 0
      })
      let list = []
      items.forEach((serviceItem) => {
        serviceItem.title = `${serviceItem.title} (${serviceItem.petCategoryTitle})`
        list.push(serviceItem)
      })
      this.availableService = list
    },
    /**
     * @description 開啟服務項目視窗
     */
    creatAvaliablePrices() {
      try {
        this.addService()
        this.checkAllPrices = this.cloneAvalibleService.length === this.catchPrices.length
        this.isIndeterminatePrices = this.catchPrices.length > 0 && this.catchPrices.length < this.cloneAvalibleService.length;
        this.pricesDialogVisible = true
      } catch (error) {
        console.error(error.message)
      }
    },

    /**
     * @description 開啟分店視窗
     */
    creatAvaliableProducts() {
      try {
        this.addProduct()
        this.checkAllProducts = this.checkboxStatus(this.catchPruducts, this.cloneProduct)
        let count = 0 // 找出可以被點選的數量
        this.catchPruducts.forEach(item => {
          if (!this.disableComputed(item)) {
            count++
          }
        })
        this.isIndeterminateProduct = count > 0 && count < this.productCanCheckCount();
        this.productsDialogVisible = true
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 開啟體型/類型視窗
     */
    creatAvaliablePrepaids() {
      try {
        this.addPrepaid()
        const total = this.validServiceCategories.length
        this.checkAllPrepaid = total > 0 && total === this.catchPrepaids.length
        this.isIndeterminateCategory = this.catchPrepaids.length > 0 && this.catchPrepaids.length < total
        this.prepaidsDialogVisible = true
      } catch (error) {
        console.error(error.message)
      }
    },
    productCanCheckCount() {
      let count = 0
      this.cloneProduct.forEach(item => {
        if (!this.disableComputed(item.id)) {
          count++
        }
      })
      return count
    },
    cancelSelectPrices() {
      this.pricesDialogVisible = false
    },
    /**
     * @description 關閉「新增適用分店」視窗
     */
    cancelSelectProducts() {
      this.productsDialogVisible = false
    },
    cancelSelectPrepaids() {
      this.prepaidsDialogVisible = false
    },
    /**
     * @description 儲存服務項目
     */
    saveSelectPrices() {
      try {
        const arr = this.unionService
        this.forSaveDeletePrice = []
        let setCatchPrices = new Set(this.catchPrices)
        this.catchPrices = Array.from(setCatchPrices)
        for (let i = 0, len = this.catchPrices.length; i < len; i++) {
          let data = arr.find(data => data.title === this.catchPrices[i])
          this.forSaveDeletePrice.push(data)
        }
        this.pricesDialogVisible = false
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 包月儲存
     */
    saveSelectPrepaids() {
      try {
        this.forSaveDeletecategoryList = []
        let setCatchPrepaid = new Set(this.catchPrepaids)
        this.catchPrepaids = Array.from(setCatchPrepaid)

        for (let i = 0, len = this.catchPrepaids.length; i < len; i++) {
          const title = this.catchPrepaids[i]
          const data = this.cloneCategoryList.find(
            (item) => item && item.categoryTitle === title
          )
          if (data) {
            this.forSaveDeletecategoryList.push(data)
          }
        }
        this.prepaidsDialogVisible = false
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 儲存選用到的分店
     */
    saveSelectProducts() {
      try {
        this.$set(this.submitData, 'storeIds', [])
        let setCatchPruducts = new Set(this.catchPruducts)
        this.catchPruducts = Array.from(setCatchPruducts)
        for (let i = 0, len = this.catchPruducts.length; i < len; i++) {
          const data = this.cloneProduct.find(item => item.id === this.catchPruducts[i])
          this.submitData.storeIds.push(data)
        }
        this.productsDialogVisible = false
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 服務 -> 跳窗 -> 全選 checkbox
     */
    handleCheckAllChangeService(val) {
      if (val && this.serviceFilter.length > 0) {
        const filterTitle = this.filterService.map(item => item.title)
        this.catchPrices = [...this.catchPrices, ...filterTitle]
      }
      if (val && this.serviceFilter.length === 0) {
        this.catchPrices = this.filterService.map(item => item.title)
      }
      if (!val && this.serviceFilter.length === 0) {
        this.catchPrices = []
      }
      if (!val && this.serviceFilter.length > 0) {
        const needFilterCategory = this.filterService.map(item => item.title)
        this.catchPrices = this.catchPrices.filter(item => !needFilterCategory.includes(item))
      }
      this.catchPrices = uniq(this.catchPrices)
      this.isIndeterminatePrices = false
    },
    /**
     * @description 體型全選checkbox 要做的事情
     */
    handleCheckAllChangeSize(val) {
      if (val && this.prepaidFilter.length > 0) {
        const filterTitle = this.filterCategoryList.map(item => item.categoryTitle)
        this.catchPrepaids = [...this.catchPrepaids, ...filterTitle]
      }
      if (val && this.prepaidFilter.length === 0) {
        this.catchPrepaids = this.filterCategoryList.map(item => item.categoryTitle)
      }
      if (!val && this.prepaidFilter.length === 0) {
        this.catchPrepaids = []
      }
      if (!val && this.prepaidFilter.length > 0) {
        const needFilterCategory = this.filterCategoryList.map(item => item.categoryTitle)
        this.catchPrepaids = this.catchPrepaids.filter(item => !needFilterCategory.includes(item))
      }
      this.catchPrepaids = uniq(this.catchPrepaids)
      this.isIndeterminateCategory = false
    },
    /**
     * @description 刪除選擇到的分店
     * @param {String} id 
     */
    deleteProduct(id) {
      this.submitData.storeIds.forEach((item, index) => {
        if (item.id === id) {
          this.submitData.storeIds.splice(index, 1)
        }
      })
    },
    /**
     * @description 刪除選到的服務項目
     */
    deletePrice(item) {
      try {
        this.forSaveDeletePrice.forEach((innerItem, index) => {
          if (item === innerItem) {
            this.forSaveDeletePrice.splice(index, 1)
          }
        })
        this.updateSubmitData()
      } catch (error) {
        console.error(error.message)
      }
    },
    deletePrepaid(item) {
      this.forSaveDeletecategoryList.forEach((categoryItem, index) => {
        if (categoryItem.id === item.id) {
          this.forSaveDeletecategoryList.splice(index, 1)
        }
      })
    },
    updateSubmitData() {
    },
    /**
     * @description 讓跳窗打開跟外面資料同步化
     */
    addProduct() {
      this.catchPruducts = []
      if (this.submitData && this.submitData.storeIds.length > 0) {
        for (let i = 0, len = this.submitData.storeIds.length; i < len; i++) {
          this.catchPruducts.push(this.submitData.storeIds[i].id)
        }
      }
    },
    addPrepaid() {
      try {
        this.catchPrepaids = []
        if (this.forSaveDeletecategoryList && this.forSaveDeletecategoryList.length > 0) {
          for (let i = 0, len = this.forSaveDeletecategoryList.length; i < len; i++) {
            const row = this.forSaveDeletecategoryList[i]
            if (row && row.categoryTitle != null) {
              this.catchPrepaids.push(row.categoryTitle)
            }
          }
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 開服務窗時，讓內外資料同步
     */
    addService() {
      try {
        this.catchPrices = []
        if (this.forSaveDeletePrice && this.forSaveDeletePrice.length > 0) {
          for (let i = 0, len = this.forSaveDeletePrice.length; i < len; i++) {
            this.catchPrices.push(this.forSaveDeletePrice[i].title)
          }
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 跳窗 - 當select時，去判斷是否已全選（分店）
     */
    handleCheckedProduct() {
      let checkedCount = 0 // 找出可以被點選的數量
      this.catchPruducts.forEach(item => {
        if (!this.disableComputed(item)) {
          checkedCount++
        }
      })
      this.checkAllProducts = checkedCount === this.productCanCheckCount();
      this.isIndeterminateProduct = checkedCount > 0 && checkedCount < this.productCanCheckCount();
    },
    /**
     * @description 點選全選checkbox做的事情
     * this.$store.state.auth.currentUserPermission.isStoreAdmin -> true 代表有被disable的數值
     */
    checkBoxAllSelectProduct(value) {
      const cloneCatchProduct = cloneDeep(this.catchPruducts)
      const notInclude = this.findNotIncludePermission(cloneCatchProduct) // 不在此分店管理者下的分店，不能動到&被disable的分店
      // 如果取消全選＋沒有分店管理
      if (!value && !this.$store.state.auth.currentUserPermission.isStoreAdmin) {
        if (this.productFilter.length > 0) {
          const cancelCheckAll = this.filterLocations.map(item => item.id) // 找出這次被filter && 取消掉的分店
          this.catchPruducts = this.catchPruducts.filter(item => !cancelCheckAll.includes(item)) // 然後將被取消的分店去掉
        } else {
          this.catchPruducts = []
        }
      }
      // 如果取消全選＋有分店管理
      if (!value && this.$store.state.auth.currentUserPermission.isStoreAdmin) {
        if (this.productFilter.length === 0) {
          this.catchPruducts = this.pushNotIncludePermission([], notInclude)
        } else {
          const cancelCheckAll = this.filterLocations.map(item => item.id) // 找出這次被filter && 取消掉的分店
          this.catchPruducts = this.catchPruducts.filter(item => !cancelCheckAll.includes(item)) // 然後將被取消的分店去掉
          this.catchPruducts = this.pushNotIncludePermission(this.catchPruducts, notInclude) // 最後要塞回被disable的分店
        }
      }

      if (value && this.productFilter.length > 0) {
        this.filterLocations.forEach(item => {
          if (!this.disableComputed(item.id)) {
            cloneCatchProduct.push(item.id)
          }
        })
        this.catchPruducts = cloneCatchProduct
      }
      if (value && this.productFilter.length === 0) {
        this.catchPruducts = []
        for (let i = 0, len = this.cloneProduct.length; i < len; i++) {
          this.catchPruducts.push(this.cloneProduct[i].id) // 先全部放入catch中
          this.catchPruducts = this.notCheckAllInPermission(this.catchPruducts) // 再filter掉未包含權限的
        }
        this.catchPruducts = this.pushNotIncludePermission(this.catchPruducts, notInclude) // 最後再加上被disable的product
      }
      this.catchPruducts = uniq(this.catchPruducts)
      this.isIndeterminateProduct = false
    },
    /**
     * @description 當select，去判斷是否已全選（中間服務項目）
     */
    handleCheckedPrice(value) {
      let checkedCount = value.length;
      this.checkAllPrices = checkedCount === this.cloneAvalibleService.length;
      this.isIndeterminatePrices = checkedCount > 0 && checkedCount < this.cloneAvalibleService.length;
    },
    /**
     * @description 當select，去判斷是否已全選（右邊包月）
     */
    handleCheckedPrepaid(value) {
      const total = this.validServiceCategories.length
      const checkedCount = value.length
      this.checkAllPrepaid = total > 0 && checkedCount === total
      this.isIndeterminateCategory = checkedCount > 0 && checkedCount < total
    },
    /**
     * @description 手動塞cloneAvalibleService
     */
    setCloneAvailableService() {
      if (this.availableService.length > 0 && this.cloneAvalibleService.length === 0) {
        this.cloneAvalibleService = JSON.parse(JSON.stringify(this.availableService))
      }

      let id = ''
      if (this.defaultValue.id) {
        id = this.defaultValue.id.toString()
      }
      if (id && id.length > 0) {
        for (let i = 0, len = this.defaultValue.serviceIds.length; i < len; i++) {
          let findData = this.availableService.find(data => data.id === this.defaultValue.serviceIds[i])
          if (findData) {
            this.forSaveDeletePrice.push(findData)
          }
        }
      }
    },
    /**
     * @description 手動塞入categoryList
     */
    setforSaveCategoryList() {
      // 有id是修改模式
      let id = ''
      if (this.defaultValue.id) {
        id = this.defaultValue.id.toString()
      }
      if (id && id.length > 0 && Array.isArray(this.defaultValue.serviceCategoryIds)) {
        for (let i = 0, len = this.defaultValue.serviceCategoryIds.length; i < len; i++) {
          const cid = this.defaultValue.serviceCategoryIds[i]
          const row = this.cloneCategoryList.find(
            (c) => c && (c.id === cid || String(c.id) === String(cid))
          )
          if (row) {
            this.forSaveDeletecategoryList.push(row)
          }
        }
      }
    },
    /**
     * @description 如果是從人事打開，要先塞入原服務
     */
    setStaffOpenService() {
      if (this.defaultValue.hasOwnProperty('staffOpenServiceTree')) {
        this.forSaveDeletecategoryList = []
        this.forSaveDeletePrice = []
        this.submitData.storeIds = []
      }
      if (this.defaultValue.hasOwnProperty('staffOpenServiceTree') && this.defaultValue.staffOpenServiceTree.type === 'add') {
        const { serviceCategoryIds, serviceIds, storeIds } = this.defaultValue.staffOpenServiceTree
        this.filterShowList(serviceCategoryIds, serviceIds, storeIds)
        this.cloneBase(this.forSaveDeletePrice, this.forSaveDeletecategoryList, this.submitData.storeIds)
      }
      if (this.defaultValue.hasOwnProperty('staffOpenServiceTree') && this.defaultValue.staffOpenServiceTree.type === 'edit') {
        const { serviceCategoryIds, serviceIds, storeIds } = this.defaultValue.staffOpenServiceTree
        const { productIds: editProductIds, serviceCategoryIds: editServiceCategoryIds, serviceIds: editServiceIds } = this.defaultValue // 所有已經儲存過的資料
        this.filterShowList(editServiceCategoryIds, editServiceIds, editProductIds)
        let editAllLocations = this.cloneProduct.filter(item => storeIds.includes(item.id))
        let editAllService = this.availableService.filter(item => serviceIds.includes(item.id))
        let editAllCategory = this.cloneCategoryList.filter(item => serviceCategoryIds.includes(item.id))
        this.initAllBase()
        this.cloneBase(editAllService, editAllCategory, editAllLocations)
      }
    },
    /**
     * @description 複製基底清單
     */
    cloneBase(allService, allCategory, allLocations) {
      this.cloneAvalibleService = JSON.parse(JSON.stringify(allService))
      this.cloneCategoryList = JSON.parse(JSON.stringify(allCategory))
      this.cloneProduct = JSON.parse(JSON.stringify(allLocations))
    },
    /**
     * @description 初始化基底清單
     */
    initAllBase() {
      this.cloneAvalibleService = []
      this.cloneCategoryList = []
      this.cloneProduct = []
    },
    /**
     * @description 修改：filter已經儲存過的資料。新增：取出此人事預設資料
     */
    filterShowList(editServiceCategoryIds, editServiceIds, editProductIds) {
      this.forSaveDeletecategoryList = this.cloneCategoryList.filter(item => editServiceCategoryIds.includes(item.id))
      this.forSaveDeletePrice = this.availableService.filter(item => editServiceIds.includes(item.id))
      this.submitData.storeIds = this.cloneProduct.filter(item => editProductIds.includes(item.id))
    },
  },
  watch: {
    /**
     * @description 按下刪除or新增服務項目儲存之後，立即更新要打出去的資料
     */
    forSaveDeletePrice(nvl, ovl) {
      let saveServiceIds = []
      for (let i = 0, len = nvl.length; i < len; i++) {
        saveServiceIds.push(nvl[i].id)        
      }
      this.$set(this.submitData, 'serviceIds', saveServiceIds)
    },
    /**
     * @description 按下刪除or新增體型儲存之後，立即更新要打出去的資料
     */
    forSaveDeletecategoryList(nvl, ovl) {
      let saveCategoryIds = []
      for (let i = 0, len = nvl.length; i < len; i++) {
        if (nvl[i] && nvl[i].id != null) {
          saveCategoryIds.push(nvl[i].id)
        }
      }
      this.$set(this.submitData, 'serviceCategoryIds', saveCategoryIds)
    }
  },
  async mounted() {
    //////////// 一組的開窗流程不要動
    await this.tryToFetchService()
    await this.tryToFetchCategory()
    await this.tryToFetchProduct()
    //////////// 一組的開窗流程不要動
    this.setforSaveCategoryList()
    this.setCloneAvailableService()
    this.setStaffOpenService()
  }
}
</script>
<template>
  <div :class="$style.serviceTreePadding">
    <el-form :rules="submitRules">
      <el-row>
        <el-col :span="16">
          <el-form-item label="適用分店及服務項目" prop="storeIds">
            <el-row :gutter="0">
              <!-- 左邊區塊 -->
              <el-col :span="12">
                <div :class="$style.box">
                  <template>
                    <div class="inner-box">
                      <el-button v-for="(item, index) in submitData.storeIds" :key="index" class="is-round is-fullwidth"
                        style="text-align: left;" :disabled="disableComputed(item.id)" @click="deleteProduct(item.id)">
                        <span class="flex-btn">
                          <span class="btn-text">{{ item.name }}</span>
                          <div style="cursor: pointer; padding: 10px; margin: -10px">
                            <BaseIcon name="times"></BaseIcon>
                          </div>
                        </span>
                      </el-button>
                      <span v-if="!submitData.storeIds.length">請選擇可服務的地點</span>
                    </div>
                  </template>
                  <el-button class="is-round is-fullwidth" style="overflow-x:auto" @click="creatAvaliableProducts">
                    <BaseIcon name="plus" /> 新增適用分店
                  </el-button>
                </div>
              </el-col>
              <!-- 中間區塊 -->
              <el-col :span="12">
                <div :class="$style.box">
                  <template>
                    <div class="inner-box">
                      <el-button v-for="(item, index) in forSaveDeletePrice" :key="item.id" class="is-round is-fullwidth"
                        style="text-align: left;">
                        <div class="flex-btn">
                          <div class="flex-btn-content">
                            <span class="btn-text">{{ item.title }}</span> <br />
                          </div>

                          <div class="flex-btn-icon" @click="deletePrice(item)">
                            <BaseIcon name="times"></BaseIcon>
                          </div>
                        </div>
                      </el-button>
                      <span v-if="!forSaveDeletePrice.length">請選擇服務項目</span>
                    </div>
                  </template>
                  <el-button class="is-round is-fullwidth" style="overflow-x:auto" @click="creatAvaliablePrices">
                    <BaseIcon name="plus" /> 新增適用服務項目
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>

        <el-col :span="8" :class="$style.overflowCategory">
          <el-form-item :label="`可服務的${$t('reserve.PET_TO_EMPTY')}類別與${$t('member.BODY_TO_TYPE')}`">
            <div :class="[$style.box]">
              <template>
                <div class="inner-box">
                  <el-button v-for="(item, index) in forSaveDeletecategoryList" :key="index" class="is-round is-fullwidth"
                    style="text-align: left;">
                    <div class="flex-btn">
                      <div class="flex-btn-content">
                        <span class="btn-text">{{ item.categoryTitle }}</span> <br />
                      </div>

                      <div class="flex-btn-icon" @click="deletePrepaid(item)">
                        <BaseIcon name="times"></BaseIcon>
                      </div>
                    </div>
                  </el-button>
                  <span v-if="!forSaveDeletecategoryList.length">請選擇可服務的{{ $t('reserve.PET_TO_EMPTY') }}類別與{{ $t('member.BODY_TO_TYPE') }}</span>
                </div>
              </template>
              <el-button class="is-round is-fullwidth" style="overflow-x:auto" @click="creatAvaliablePrepaids">
                <BaseIcon name="plus" /> 新增可服務的{{ $t('reserve.PET_TO_EMPTY') }}類別與{{ $t('member.BODY_TO_TYPE') }}
              </el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!-- 新增適用適用分店，跳窗 -->
    <el-dialog title="選取適用分店" :visible.sync="productsDialogVisible" width="80%" top="0" append-to-body>
      <el-input :placeholder="'輸入分店名稱'" class="is-border smsInput" style="margin-bottom: 15px;" v-model="productFilter">
        <BaseIcon slot="prefix" name="search" class="el-input__icon" />
      </el-input>
      <el-form label-position="top" class="isWrap">
        <el-form-item style="min-height: 250px" :class="$style['services-wrap']">
          <div :class="$style.dialogTitle">
            <el-checkbox :indeterminate="isIndeterminateProduct" v-model="checkAllProducts"
              @change="checkBoxAllSelectProduct" style="margin-left: 5px; margin-top: 10px; margin-bottom: 5px">全 選
            </el-checkbox>
          </div>
          <el-checkbox-group v-model="catchPruducts" :class="$style.services" @change="handleCheckedProduct">
            <el-checkbox v-for="(product, index) in filterLocations" :disabled="disableComputed(product.id)" :key="index"
              :label="product.id" border>
              {{ product.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div class="btn-group-inline">
        <el-button class="is-round" @click="cancelSelectProducts">取消</el-button>
        <el-button class="is-round" type="primary" @click="saveSelectProducts">儲存</el-button>
      </div>
    </el-dialog>

    <!-- 新增適用服務項目，跳窗 -->
    <el-dialog title="選取適用服務" :visible.sync="pricesDialogVisible" width="80%" top="0" append-to-body>
      <el-input :placeholder="'輸入服務名稱'" class="is-border smsInput" style="margin-bottom: 15px;" v-model="serviceFilter">
        <BaseIcon slot="prefix" name="search" class="el-input__icon" />
      </el-input>
      <el-form label-position="top" class="isWrap">
        <el-form-item style="min-height: 250px" :class="$style['services-wrap']">
          <div :class="$style.dialogTitle">
            <el-checkbox :indeterminate="isIndeterminatePrices" v-model="checkAllPrices"
              style="margin-left: 5px; margin-top: 10px; margin-bottom: 5px" @change="handleCheckAllChangeService">全 選
            </el-checkbox>
          </div>
          <el-checkbox-group v-model="catchPrices" :class="$style.services" @change="handleCheckedPrice">
            <el-checkbox v-for="(service, index) in unionService" :key="index" :label="service.title" border>
              {{ service.title }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>

      <div class="btn-group-inline">
        <el-button class="is-round" @click="cancelSelectPrices">取消</el-button>
        <el-button class="is-round" type="primary" @click="saveSelectPrices">儲存</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="`新增可服務的${$t('reserve.PET_TO_EMPTY')}類別與${$t('member.BODY_TO_TYPE')}`"
      :visible.sync="prepaidsDialogVisible" width="80%" top="0" append-to-body>
      <el-input :placeholder="`輸入類別或${$t('member.BODY_TO_TYPE')}`" class="is-border smsInput" style="margin-bottom: 15px;"
        v-model="prepaidFilter">
        <BaseIcon slot="prefix" name="search" class="el-input__icon" />
      </el-input>
      <el-form label-position="top" class="isWrap">
        <el-form-item style="min-height: 250px" :class="$style['services-wrap']">
          <div :class="$style.dialogTitle">
            <el-checkbox :indeterminate="isIndeterminateCategory" v-model="checkAllPrepaid"
              style="margin-left: 5px; margin-top: 10px; margin-bottom: 5px" @change="handleCheckAllChangeSize">全 選
            </el-checkbox>
          </div>
          <el-checkbox-group v-model="catchPrepaids" :class="$style.services" @change="handleCheckedPrepaid">
            <el-checkbox v-for="(item, index) in filterCategoryList" :key="index" :label="item.categoryTitle" border>
              {{ item.categoryTitle }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>

      <div class="btn-group-inline">
        <el-button class="is-round" @click="cancelSelectPrepaids">取消</el-button>
        <el-button class="is-round" type="primary" @click="saveSelectPrepaids">儲存</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<style lang="scss" module>
.serviceTreePadding {
  padding: 0 0 100px;

  :global {
    .el-form-item__label {
      float: none !important;
    }
  }
}

.box {
  background-color: #f9f9f9;
  border: $color-border-light 1px solid;
  padding: 15px;
  border-radius: 6px;

  :global {
    .inner-box {
      margin-bottom: 20px;
      height: calc(100vh - 380px);
      overflow-y: scroll;
    }

    .box {
      &__title {
        white-space: normal;
        text-align: left;
        line-height: 1.4;
        max-width: calc(100% - 100px);
      }
    }

    .el-checkbox-group {
      display: flex;
      flex-wrap: wrap;
    }

    .el-checkbox.is-bordered {
      background-color: #fff;

      .el-checkbox__label {
        white-space: normal;
      }
    }

    .search-in-box {
      .el-input__inner {
        background-color: #fff;
        margin-left: 5px;
        margin-right: 5px;
        margin-bottom: 10px;
      }
    }

    .input-in-buttom {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
    }

    .el-form-item {
      margin-bottom: 15px;
    }

    .el-button {
      .el-input {
        width: 100px;
      }

      .el-input__inner {
        background-color: #fff;
        border-color: $color-border-base;
        height: 30px;

        &:focus {
          // border-color: $color-primary;
        }
      }

      .el-input__suffix {
        top: 7px;
      }
    }

    .inline-section {
      display: flex;
      margin-bottom: 15px;
    }

    .el-button.is-no-border {
      border: 0;
    }
  }
}

.overflowCategory {
  padding-left: 10px;

  :global {
    .el-form-item__label {
      overflow-x: scroll;
      height: 40px;
    }
  }
}

.services-wrap {
  border: 1px solid $color-border-for-bg-white;
  border-radius: $border-radius;
  // margin: 0 -5px 30px;
}

.dialogTitle {
  background-color: $color-line;
  padding-left: 15px;
}

.services {
  padding: 15px;

  :global {
    label.el-checkbox.is-bordered {
      width: calc(50% - 10px);
      display: inline-flex;
      margin: 5px;
      align-items: center;
      height: auto;
      padding: 15px 20px 15px 15px;

      @include max-sm {
        width: 100%;
      }

      // .el-checkbox__inner {
      //   border-radius: 10px;
      //   width: 18px;
      //   height: 18px;

      //   &:after {
      //     left: 5px;
      //     top: 2px;
      //     height: 8px;
      //     width: 4px;
      //     border-width: 2px;
      //   }
      // }

      .el-checkbox__label {
        padding-left: 15px;
        width: 100%;
        overflow-x: auto;
      }

      &+.el-checkbox.is-bordered {
        margin-left: 5px;
      }

      .title,
      .meta {
        width: calc(100% - 20px);
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
      }

      .content {
        width: 100%;
      }
    }
  }
}
</style>